import styles from "./Oneday.module.css";
import ScrollReveal from "../Ui/ScrollReveal";

function Oneday() {
    return (
        <div className={styles.onedayWrap}>
            <ScrollReveal>
                <section className={styles.section01}>
                <div className={styles.imgbox}>
                    <img
                        src="/image/business-meeting-with-colleagues-at-office.png"
                        alt="컬러 이미지"
                    />
                </div>
                <div className={styles.infoBox}>
                    <div className={styles.infoHeader}>
                        <p className={styles.subtitle}>
                            Institutions/Companies
                        </p>
                        <p className={styles.koTitle}>
                            기관 / 기업 교육 프로그램
                        </p>
                    </div>
                    <div className={styles.infoDetail}>
                        <div className={styles.infoDesc}>
                            <span>
                                기업 교육은 워크샵, 특강, 전문가 양성 교육이 가능하며 이미지, 테라피, 인문학, 마케팅 등 기업맞춤 교육을 제안합니다.
                            </span>
                            <span>
                                기업 출강 강의는 원하는 교육을 선택 후, 협회로 문의주시면 고객사의 니즈에 맞게 상세 커리큘럼을 조정하여 맞춤형 교육으로 진행됩니다. 과정 세팅을 위해 원하시는 교육 주제, 인원, 교육 방법에 대해 문의 부탁드립니다.
                            </span>
                        </div>
                    </div>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section02}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}> program </p>
                    <h2 className={styles.title}>
                        이미지 메이킹
                    </h2>
                </div>
                <div className={styles.line}></div>
                <div className={styles.targetSubtitleWrap}>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span> 직장인으로서 자기연출을 위한 기술을 습득하는 과정</span>
                    </p>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span> 개인의 이미지와 인간관계의 영향 및 자기표현 방향을 설정하는 과정</span>
                    </p>
                </div>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>과목</th>
                                <th>주요내용</th>
                                <th>시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>호감가는 이미지 메이킹</td>
                                <td>
                                    <ul>
                                        <li>이미지의 중요성</li>
                                        <li>컬러 커뮤니케이션 기법을 활용한 첫인상 만들기 전략</li>
                                        <li>체형진단을 통한 퍼스널 컬러, 스타일 연출법</li>
                                        <li>호감 가는 헤어, 메이크업 전략</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>퍼스널 컬러</td>
                                <td>
                                    <ul>
                                        <li>직종, 분야별 긍정적 이미지메이킹의 핵심 알기</li>
                                        <li>컬러는 왜 중요할까? - 나에게 어울리는 컬러 찾기</li>
                                        <li>[실습] 웜, 쿨 베이스/ 타입 /톤 진단</li>
                                        <li>컬러의 매칭 방법과 활용법</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>면접 이미지</td>
                                <td>
                                    <ul>
                                        <li>목표 기업에 따른 면접 스타일링(헤어/패션/메이크업) 방법</li>
                                        <li>TPO에 맞는 스타일링 어드바이스</li>
                                        <li>면접스피치, 면접 매너, 모의 면접을 통한 이미지 코칭</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>비즈니스 매너</td>
                                <td>
                                    <ul>
                                        <li>에티켓과 매너의 차이</li>
                                        <li>상황별 비즈니스매너가 중요한 이유</li>
                                        <li>인사/전화/커뮤니케이션 등을 통한 비즈니스 매너 전략 바로알기</li>
                                        <li>언택트 시대 비대면 매너 체크</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section03}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}> program </p>
                    <h2 className={styles.title}>
                        컬러힐링 워크샵
                    </h2>
                </div>
                <div className={styles.line}></div>
                <div className={styles.targetSubtitleWrap}>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span> 직장인으로서 자기연출을 위한 기술을 습득하는 과정</span>
                    </p>
                    <p className={styles.targetSubtitle}>
                        <span className={styles.pointcolor}>✓</span>
                        <span> 개인의 이미지와 인간관계의 영향 및 자기표현 방향을 설정하는 과정</span>
                    </p>
                </div>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>과목</th>
                                <th>주요내용</th>
                                <th>시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>소통과 치유의 컬러테라피</td>
                                <td>
                                    <ul>
                                        <li>컬러테라피 원리의 이해 - 컬러의 기본 속성과 심리의 연관성 파악</li>
                                        <li>컬러 롤링페이퍼 - 타인이 느끼는 나의 색은 무엇일까?</li>
                                        <li>[실습] 나만의 색 찾기 - 끌리는 색으로 알아보는 내면의 무의식</li>
                                        <li>[실습] 나만의 색 찾기 -탄생컬러와 보완컬러로 알아보는 소통법</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>컬러 인문학</td>
                                <td>
                                    <ul>
                                        <li>내 삶을 바꾸는 강력한 언어 컬러의 힘</li>
                                        <li>화가들의 그림 역사 or 영화를 통한 컬러심리 찾기</li>
                                        <li>일상에서의 시각적 컬러 활용기법</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>컬러 액자 만들기</td>
                                <td>
                                    <ul>
                                        <li>컬러 심리의 이해 및 진정한 자기 공감의 중요 요소 파악하기</li>
                                        <li>컬러의 선택, '관점/상황/생각'에 따른 서로의 다름 인정하기</li>
                                        <li>현재/미래/과거에 생각나는 컬러 탐색, 12가지 컬러 이야기</li>
                                        <li>[실습] 나의 컬러로 빚는 스칸디아모스 컬러액자 만들기</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                            <tr>
                                <td>컬러 이미지 트레이닝</td>
                                <td>
                                    <ul>
                                        <li>생활 속 컬러 힐링 사례와 컬러가 주는 심리적 메시지 알기</li>
                                        <li>컬러가 지니고 있는 긍정심리와 부정심리</li>
                                        <li>감정을 다루기 위한 이미지 트레이닝 기법</li>
                                        <li>몸을 이완시키는 컬러 호흡법과 스트레칭으로 셀프 케어</li>
                                    </ul>
                                </td>
                                <td>
                                    3H
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            </ScrollReveal>
        </div>
    );
}

export default Oneday;

